import { createContext, useContext } from 'react';
export const initialContext = {};
export const WalletManagementContext = createContext(initialContext);
export const useWalletManagementConfig = () => useContext(WalletManagementContext);
//# sourceMappingURL=WalletManagementContext.js.map